import { createSlice ,current} from '@reduxjs/toolkit';

const initialState = {
    number: 10
}

const numberSlice = createSlice({
    name: 'number',
    initialState,
    reducers: {
        addNumber: (state, action) => {
            state.number += action.payload ;
            console.log(current(state));

        }
    }
});

export const { addNumber} = numberSlice.actions;
export default numberSlice.reducer;